import FolderIcon from "@mui/icons-material/Folder";
import { Box, IconButton } from "@mui/material";
import { useTranslation } from "common/locales";
import { useProgrammeActions } from "model";
import { useNavigate } from "react-router-dom";
import { mixpanel } from "../../common/analytics";
import AssessmentsSection from "./AssessmentsSection";
import InsightsSection from "./InsightsSection";
import YieldInsightsCards from "./YieldInsightsCards";

export function FarmInsights() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: programmes = [] } = useProgrammeActions();

  const isInProgramme = programmes.length > 0;

  const handleFileManager = () => {
    mixpanel.track("File manager clicked from assessments section");
    navigate("/file-management-overview");
  };

  const fileManagerButton = isInProgramme ? (
    <IconButton
      onClick={handleFileManager}
      size="small"
      sx={{
        backgroundColor: "#F1EFF7",
        color: "#7D5DA3",
        "&:hover": { backgroundColor: "#E5E1F0" },
      }}
      aria-label={t("go.to.file.management.button")}
    >
      <FolderIcon fontSize="small" />
    </IconButton>
  ) : undefined;

  return (
    <>
      {/* Safe area inset for mobile */}
      <Box sx={{ paddingTop: "env(safe-area-inset-top)" }} />

      <Box
        sx={{
          backgroundColor: "#FFFFFF",
          minHeight: "100%",
          paddingTop: "20px",
          paddingBottom: "20px",
        }}
      >
        {/* Farm Performance Section (Yield Dashboard) */}
        <InsightsSection title={t("insights.farmPerformance.title")}>
          <YieldInsightsCards />
        </InsightsSection>

        {/* Assessments & Recommendations Section */}
        <InsightsSection
          title={t("insights.assessments.title")}
          actionButton={fileManagerButton}
        >
          <AssessmentsSection />
        </InsightsSection>
      </Box>
    </>
  );
}
